module.exports = __webpack_public_path__ + "img/bitcoin-cash.323acc44.png";